export default __webpack_public_path__ + "static/Confetti-Mobile-436fb8a06901f15c7d3b39a1fab58734.svg";